"use client";

import TopBar from "@components/TopBar";

export default function BasicLayout({ children }: { children: JSX.Element }) {
  return (
    <>
      <TopBar />
      {children}
    </>
  );
}
